import { render, staticRenderFns } from "./SalesSettings.vue?vue&type=template&id=0f131ed6"
import script from "./SalesSettings.vue?vue&type=script&lang=js"
export * from "./SalesSettings.vue?vue&type=script&lang=js"
import style0 from "./SalesSettings.vue?vue&type=style&index=0&id=0f131ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports